import { Component, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit, AfterContentInit, AfterContentChecked, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Params } from '../../../../../transactions/pages/list/models/params.model';
import { UserService } from '../../../../../../core/services/user.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Component({
    selector: 'app-flow-filter2',
    templateUrl: './flow-filter.component.html',
    styleUrls: ['./flow-filter.component.scss']
})
export class FlowFilter2Component implements OnInit {

    @Input() filter: any;
    @Input() flow_order: any;
    @Output() removeFilter = new EventEmitter();

    expandedStepState: boolean = true;
    model: any = {};
    params: Params;
    @Input() is_default: any;
    @Input() operations: any;
    @Input() terms: any;
    @Input() onlyViewer;
    @Input() index;
    @Input() form;
    @ViewChild('editInput') editElement: ElementRef;
    @ViewChild('filter_name') filterNameElement: ElementRef;
    //myForm: FormGroup = new FormGroup({});;

    constructor(
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private userService: UserService,
        private translateService: TranslateService
    ) {

    }

    ngOnInit(): void {
        this.model.user = this.userService.user;
        this.route.paramMap.subscribe(params => {
            this.params = new Params(params);
            this.model.partner = params.get('partner');
            this.model.account = params.get('account');
        });
        this.filter.name = this.filter.name ? this.filter.name : this.translateService.instant('flows.detail.filter_name');
        this.model.expressions = [];
        if (this.filter.expression) {
            if (this.filter.expression.nary_expr) {

                this.filter.expression.nary_expr.expression_list.forEach(expression => {

                    var newExpression = this.createExpression(expression.binary_expr.left.var_expr.var_name, expression.binary_expr.symbol);
                    expression.binary_expr.id = newExpression.id;
                    expression.binary_expr.terms = newExpression.terms;
                    expression.binary_expr.operators = newExpression.operators;
                    expression.binary_expr.values = newExpression.values;
                    expression.binary_expr.symbol_not_translate = expression.binary_expr.symbol;
                    expression.binary_expr.terms_filtered = newExpression.terms;
                    expression.binary_expr.operators_filtered = newExpression.operators;
                    expression.binary_expr.values_filtered = newExpression.values;

                    this.form.addControl('options' + newExpression.id, this.createCtrlOptions());

                    var optionModel = this.terms.find(p => p.name == (expression.binary_expr.left.var_expr.var_name ? expression.binary_expr.left.var_expr.var_name : ''));
                    if (optionModel) {
                        this.form.addControl('operators' + newExpression.id, this.createCtrlOperators(optionModel.type));
                    } else {
                        this.form.addControl('operators' + newExpression.id, this.createCtrlOperators(null));
                    }

                    if (optionModel) {
                        this.form.addControl('values' + newExpression.id, this.createCtrlValues(optionModel.name));
                    } else {
                        this.form.addControl('values' + newExpression.id, this.createCtrlValues(null));
                    }


                    if (this.onlyViewer || this.is_default) {
                        this.form.get('options' + newExpression.id).disable();
                        this.form.get('operators' + newExpression.id).disable();
                        this.form.get('values' + newExpression.id).disable();
                    }

                    if (!expression.binary_expr.left.var_expr.var_name) {
                        this.form.get('operators' + newExpression.id).disable();
                        this.form.get('values' + newExpression.id).disable();
                    }

                    this.form.get('options' + newExpression.id).setValue(expression.binary_expr.left.var_expr.var_name ? expression.binary_expr.left.var_expr.var_name : '');
                    this.form.get('operators' + newExpression.id).setValue(expression.binary_expr.symbol ? expression.binary_expr.symbol : '');
                    this.form.get('values' + newExpression.id).setValue(expression.binary_expr.right.const_expr.const ? expression.binary_expr.right.const_expr.const : '');

                    //this.validateAllFormFields.emit(this.form);

                    this.form.get('options' + newExpression.id).updateValueAndValidity();
                    this.form.get('operators' + newExpression.id).updateValueAndValidity();
                    this.form.get('values' + newExpression.id).updateValueAndValidity();

                });
            }
        } else {
            this.filter.expression = { nary_expr: { expression_list: [] = [] } }
            this.createNewExpression();
        }


    }

    valuechangeOption(expression, value, $event) {
        let filteredOptions: Observable<any>;
        const filterValue = value ? value.toLowerCase() : '';
        if (expression.binary_expr.terms) {
            filteredOptions = expression.binary_expr.terms.filter(option => option.name.toLowerCase().includes(filterValue));
            expression.binary_expr.terms_filtered = filteredOptions;
        }
    }

    valuechangeOperators(expression, value, $event) {
        let filteredOptions: Observable<any>;
        const filterValue = value ? value.toLowerCase() : '';
        if (expression.binary_expr.operators) {
            filteredOptions = expression.binary_expr.operators.filter(option => option.toLowerCase().includes(filterValue));
            expression.binary_expr.operators_filtered = filteredOptions;
        }
    }

    valuechangeValues(expression, value, $event) {
        let filteredOptions: Observable<any>;
        const filterValue = value ? value.toLowerCase() : '';
        if (expression.binary_expr.values)
            if (expression.binary_expr.values.length > 0) {
                filteredOptions = expression.binary_expr.values.filter(option => option.toLowerCase().includes(filterValue));
                expression.binary_expr.values_filtered = filteredOptions;
            }
    }

    hasTranslation(key: string): boolean {
        const translation = this.translateService.instant(key);
        return translation !== key && translation !== '';
    }

    blurEventOption(event, expression) {

        expression.binary_expr.left.var_expr.var_name = event.target.value;

        if (event.target.value.startsWith("Custom.")) {
            this.form.get("options" + expression.binary_expr.id).setValidators(null);
        }

        if (!this.form.get("options" + expression.binary_expr.id).hasError('options')) {
            this.selectedOption(expression, event.target.value);
        }

    }
    blurEventOperators(event, expression) {
        if (event.target.value) {
            expression.binary_expr.symbol = this.translateService.instant(event.target.value).replace(/^\s+|\s+$/g, "");
            expression.binary_expr.symbol_not_translate = event.target.value;
        }

    }
    blurEventValues(event, expression) {
        expression.binary_expr.right.const_expr.const = event.target.value;
    }


    createCtrlOptions() {
        var ctrl: AbstractControl = null;
        let val: any[] = [];
        ctrl = new FormControl(null, val);
        ctrl.setValidators([this.validatorTerms(this.terms), Validators.required]);

        ctrl.updateValueAndValidity();
        return ctrl;
    }

    createCtrlOperators(type) {

        var ctrl: AbstractControl = null;
        let val: any[] = [];
        ctrl = new FormControl(null, val);
        if (type)
            ctrl.setValidators([this.validatorOperators(type), Validators.required]);
        else
            ctrl.setValidators([this.validatorOperators(null), Validators.required]);

        ctrl.updateValueAndValidity();
        return ctrl;
    }

    createCtrlValues(name) {

        var ctrl: AbstractControl = null;
        let val: any[] = [];
        ctrl = new FormControl(null, val);

        if (name)
            ctrl.setValidators([this.validatorValues(name), Validators.required]);
        else
            ctrl.setValidators([this.validatorValues(null), Validators.required]);

        ctrl.updateValueAndValidity();
        return ctrl;
    }

    validatorTerms(names): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {

            if (control.value?.startsWith("Custom.")) {
                return null;
            }


            const index = names.findIndex(name => {
                if (control.value)
                    return (new RegExp('\^' + name.name + '\$')).test(control.value);
                return true;
            });
            return index < 0 ? { 'options': { value: control.value } } : null;
        };
    }

    validatorOperators(type): ValidatorFn {

        return (control: AbstractControl): { [key: string]: any } | null => {
            if (type) {
                const index = this.operations?.find(p => p.type == type).operators.findIndex(operator => {
                    if (control.value)
                        return (new RegExp('\^' + operator + '\$')).test(control.value);
                    return true;
                });
                return index < 0 ? { 'operators': { value: control.value } } : null;
            } else {
                const index = this.operations?.map(p => p.operators).findIndex(operator => {
                    if (control.value)
                        return (new RegExp('\^' + operator + '\$')).test(control.value);
                    return true;
                });
                return index < 0 ? { 'operators': { value: control.value } } : null;
            }

        };
    }

    validatorValues(name): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (name) {
                if (name) {
                    if (this.terms.find(p => p.name == name)) {
                        if (this.terms.find(p => p.name == name).type == 'list') {
                            const index = this.terms.find(p => p.name == name).values.findIndex(operator => {
                                if (control.value)
                                    return (new RegExp('\^' + operator + '\$')).test(control.value);
                                return true;
                            });
                            return index < 0 ? { 'values': { value: control.value } } : null;
                        }
                        return null;
                    }

                    return null;
                }
            }
            return null;
        };
    }

    createNewExpression() {

        var exp = {
            binary_expr: {
                id: '_' + Math.random().toString(36).substr(2, 9),
                terms: this.terms,
                terms_filtered: this.terms,
                left: {
                    var_expr: { var_name: '' },
                },
                operators: this.operations?.find(p => this.terms[0].type == p.type).operators,
                operators_filtered: this.operations?.find(p => this.terms[0].type == p.type).operators,
                right: {
                    const_expr: { const: '' }
                },
                values: this.terms[0].values,
                values_filtered: this.terms[0].values,
                disabled: false
            }
        };
        this.filter.expression.nary_expr.expression_list.push(exp);

        this.form.addControl('options' + exp.binary_expr.id, this.createCtrlOptions());
        this.form.addControl('operators' + exp.binary_expr.id, this.createCtrlOperators(null));
        this.form.addControl('values' + exp.binary_expr.id, this.createCtrlValues(null));

        this.form.get('operators' + exp.binary_expr.id).disable();
        this.form.get('values' + exp.binary_expr.id).disable();

    }

    removeStep(event: any, id) {
        let obj = this.filter.expression.nary_expr.expression_list.find(p => p.binary_expr.id == id);

        this.form.removeControl('options' + obj.binary_expr.id);
        this.form.removeControl('operators' + obj.binary_expr.id);
        this.form.removeControl('values' + obj.binary_expr.id);

        this.form.updateValueAndValidity();

        const index = this.filter.expression.nary_expr.expression_list.indexOf(obj);
        if (index > -1) {
            this.filter.expression.nary_expr.expression_list.splice(index, 1);
        }

        event.stopPropagation();

    }

    editStep(event, name) {
        this.filter.name = name;
        event.stopPropagation();

    }

    selectedOption(expression, value) {
        var optionModel = this.terms.find(p => p.name == value);
        if (optionModel) {
            var operatorsPossiblesByOption = this.operations?.find(p => p.type == optionModel.type).operators;

            this.form.get('operators' + expression.binary_expr.id).setValue(null);
            this.form.get('values' + expression.binary_expr.id).setValue(null);

            expression.binary_expr.operators = operatorsPossiblesByOption;
            expression.binary_expr.values = optionModel.values;

            expression.binary_expr.operators_filtered = operatorsPossiblesByOption;
            expression.binary_expr.values_filtered = optionModel.values;

            this.form.get('operators' + expression.binary_expr.id).enable();
            this.form.get('values' + expression.binary_expr.id).enable();

            this.form.get('operators' + expression.binary_expr.id).setValidators([this.validatorOperators(optionModel.type), Validators.required])
            this.form.get('operators' + expression.binary_expr.id).updateValueAndValidity();

            if (optionModel.type == 'list') {
                this.form.get('values' + expression.binary_expr.id).setValidators([this.validatorValues(optionModel.name), Validators.required])
                this.form.get('values' + expression.binary_expr.id).updateValueAndValidity();
            } else {
                this.form.get('values' + expression.binary_expr.id).setValidators([Validators.required])
                this.form.get('values' + expression.binary_expr.id).updateValueAndValidity();
            }
        }
    }

    createExpression(option: any, operator: any) {

        var term = this.terms.find(p => p.name.toLowerCase() == option.toLowerCase());
        var operatorsPossiblesByOption = term ? this.operations?.find(p => p.type == term.type).operators : operator; //operadores possives

        return {
            id: '_' + Math.random().toString(36).substr(2, 9),
            terms: this.terms,
            terms_filtered: this.terms,
            operators: term ? operatorsPossiblesByOption : null,
            operators_filtered: term ? operatorsPossiblesByOption : null,
            values: term ? term.values : null,
            values_filtered: term ? term.values : null,
            disabled: false
        };
    }

    remove($event) {
        this.removeFilter.emit(this.filter);

    }

    clickEditName() {
        setTimeout(() => {
            this.editElement.nativeElement.select();
        }, 100);
    }

    inputNameKeyupEnter(event) {
        this.editStep(event, this.filter.name);
        this.filterNameElement.nativeElement.hidden = false;
    }

}
